module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-goldy.605fae94.png";